export enum SorterEnum {
	NOME = 1,
	DATA = 2,
	VERSAO = 3
}